<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-container class="pa-0 ma-0">
      <v-layout v-if="display_advanved_filters_applied.items.length > 0" row align-center>
        <div class="result_box_no_border sm1 no-gutters pa-0 mr-0 ml-4">
          <v-tooltip left>
            <template v-slot:activator="{on, attrs}">
              <v-icon
                v-on="on"
                @click="$store.commit('toggleMainFilter', true)"
                class="mt-3 mr-4"
                >mdi-filter-variant-plus
              </v-icon>
            </template>
            <span>Click to open filters selection</span>
          </v-tooltip>
        </div>

        <v-flex sm9 m9 lg10 xl11 class="mt-1 no-gutters ml-3">
          <v-expansion-panels class="ma-0 pa-0">
            <v-expansion-panel class="elevation-0 ml-0">
              <v-expansion-panel-header class="ma-0 pa-0">
                <template v-slot:default="{open}">
                  <!--              <span v-if="open" class="ma-0 pa-0 ml-6">Current active filters.</span>-->
                  <v-row v-if="open" class="justify-space-between align-center">
                    <v-flex class="ml-5" sm10>
                      <span class="ma-0 pa-0 ml-1">Current active method filters </span>
                      <v-btn
                        x-small
                        text
                        @click.prevent="
                          html_to_xls_download('results_current_filters');
                          open = true;
                        "
                      >
                        <v-icon class="green--text">mdi-microsoft-excel</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-row>
                  <span v-else class="ml-2"
                    >Click to view applied method filters ({{
                      display_advanved_filters_applied['items'].length
                    }})</span
                  >
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ma-0 pa-0" eager>
                <v-data-table
                  id="results_current_filters"
                  :headers="display_advanved_filters_applied['headers']"
                  :items="display_advanved_filters_applied['items']"
                  class="elevation-1 ma-0 pa-0"
                  dense
                  :footer-props="{
                    'items-per-page-options': [
                      display_advanved_filters_applied['items'].length,
                    ],
                  }"
                ></v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
      </v-layout>
      <v-layout v-else class="ml-0 mr-1 green--text" row align-center>
        <v-flex sm9 m9 lg10 xl10 class="mt-1 no-gutters ml-3">
          <v-icon class="ml-0">mdi-filter-variant-plus</v-icon>
          <span class="ml-6">No filters selected</span>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// import helpLink from "@/components/application-level/help-system/help-link";

import display_advanved_filters_applied from '@/components/trade-dsm-application/mixins/applied_filters';

const {csvExport} = require('@/components/application-level/js_functions/jsFunctions');
const {
  html_to_xls_download,
} = require('@/components/application-level/js_functions/jsFunctions');

const {
  calc_items_per_page,
} = require('@/components/trade-dsm-application/mixins/calc_items_per_page');

// const _ = require('lodash');

export default {
  name: 'applied_filters_box',
  components: {
    // helpLink
  },
  methods: {
    csv: csvExport,
    calc_items_per_page: calc_items_per_page,
    html_to_xls_download: html_to_xls_download,
  },
  mixins: [display_advanved_filters_applied],
  watch: {
    // eslint-disable-next-line no-unused-vars
    display_advanved_filters_applied(new_v, old_v) {
      // console.log(old_v)
      if (new_v.items.length === 0) {
        // remove the orange tick on the left sidebar if there is no filters active

        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.advanced_filters_is_dirty = false;
      }
    },
  },
  computed: {
    // display_advanved_filters_applied() {
    //   // let return_list = {headers: [], items: []};
    //   let items = [];
    //   // console.log(_.clone(items));
    //   if (
    //     this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.exclusions_for_display.markets.exclusions.map(
    //       v => this.codeToMarket(v),
    //     ).length > 0 &&
    //     this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.load_presets
    //   ) {
    //     items.push({
    //       col_name: 'Excluded countries',
    //       selected_value_min: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.exclusions_for_display.markets.exclusions.map(
    //         v => this.codeToMarket(v),
    //       ),
    //     });
    //   }
    //
    //   if (
    //     this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets
    //       .exclusions_for_display.products.exclusions.length > 0 &&
    //     this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.load_presets
    //   ) {
    //     items.push({
    //       col_name: 'Excluded products',
    //       selected_value_min: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
    //         .presets.exclusions_for_display.products.exclusions,
    //     });
    //   }
    //
    //   let keys_already_done = [];
    //   for (let key in this.$store.state.tradeDSM.dsm_filter_setttings.Filters) {
    //     if (key !== 'META') {
    //       let entries = this.$store.state.tradeDSM.dsm_filter_setttings.Filters[key]
    //         .entries;
    //
    //       for (let i = 0; i < entries.length; i++) {
    //         let entry = entries[i];
    //         let col_name = entry.col_name;
    //         keys_already_done.push(col_name);
    //         keys_already_done.push(col_name + '__lte');
    //         keys_already_done.push(col_name + '__gte');
    //
    //         if (entry.selected_value.length > 0) {
    //           let name =
    //             entry.display_unit === 'currency'
    //               ? ' [' + this.multiplerString + ' ' + this.currencyString + ']'
    //               : '';
    //           let conversion =
    //             entry.display_unit === 'currency'
    //               ? this.exchangeRate / this.mulitplier
    //               : 1;
    //           items.push({
    //             col_name: entry.name + name,
    //             selected_value_min:
    //               entry.type === 'dropdown'
    //                 ? `${entry.selected_value[0] * conversion} => v <= ${entry
    //                     .selected_value[1] * conversion}`
    //                 : entry.selected_value[0] === 0
    //                 ? 'No'
    //                 : 'Yes',
    //           });
    //         } else {
    //           if (entry.col_name === 'Avg6Major') {
    //             let filter_text = '';
    //             let p = false;
    //             if (
    //               'Avg6Major__lte' in
    //               this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
    //                 .custom_query
    //             ) {
    //               filter_text =
    //                 this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
    //                   .custom_query['Avg6Major__lte'] *
    //                   this.value_convertion +
    //                 '<= v ';
    //               p = true;
    //             }
    //             if (
    //               'Avg6Major__gte' in
    //               this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
    //                 .custom_query
    //             ) {
    //               filter_text +=
    //                 '>= ' +
    //                 this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
    //                   .custom_query['Avg6Major__gte'] *
    //                   this.value_convertion;
    //               p = true;
    //             }
    //             if (p === true) {
    //               items.push({
    //                 col_name:
    //                   'Untapped Potential [' +
    //                   this.multiplerString +
    //                   ' ' +
    //                   this.currencyString +
    //                   ']',
    //                 selected_value_min: filter_text,
    //               });
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    //
    //   // special filters
    //   let special = JSON.parse(
    //     JSON.stringify(
    //       this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.custom_query,
    //     ),
    //   );
    //   keys_already_done.forEach(k => {
    //     delete special[k];
    //   });
    //   Object.keys(special).forEach(k => {
    //     items.push({
    //       col_name: k,
    //       selected_value_min: special[k],
    //     });
    //   });
    //
    //   // provincial share
    //   let share = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
    //     .PROVINCIAL_FILTER_VALUE;
    //   if (
    //     (this.$store.state.app.selectedModelName !== 'National' && share[0] !== 0) ||
    //     share[1] !== 100
    //   ) {
    //     items.push({
    //       col_name: 'F5 ' + this.$store.state.app.selectedModelName + ' Share',
    //       selected_value_min: ` ${share[0]} <= Share <= ${share[1]}`,
    //     });
    //   }
    //
    //   // add REO
    //   let REO_row = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
    //     .selections.reo_clicked.REO_row;
    //   let REO_col = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
    //     .selections.reo_clicked.REO_col;
    //
    //   let rows = [
    //     'Not classified as REO',
    //     '1-Large but Stable Market',
    //     '2-Growing Market (Short & Long term)',
    //     '3-Large Growing Market (Short term)',
    //     '4-Large Growing Market (Long term)',
    //     '5-Large Growing Market (Short & Long term)',
    //   ];
    //   for (let row_to_check = 0; row_to_check < rows.length; row_to_check++) {
    //     if (_.includes(REO_row, row_to_check)) {
    //       items.push({
    //         col_name: rows[row_to_check],
    //         selected_value_min: `Yes`,
    //       });
    //     }
    //   }
    //
    //   let cols = [
    //     '1-Small Market Share (0 ≤ S < 5%)',
    //     '2-Intermediate Small Market Share (5 ≤ S < 15%)',
    //     '3-Intermediate Large Market Share (15 ≤ S < 25%)',
    //     '4-Large Market Share (25% < S)',
    //   ];
    //   for (let col_to_check = 0; col_to_check < cols.length; col_to_check++) {
    //     if (_.includes(REO_col, col_to_check + 1)) {
    //       items.push({
    //         col_name: cols[col_to_check],
    //         selected_value_min: `Yes`,
    //       });
    //     }
    //   }
    //
    //   let headers = [
    //     {
    //       text: 'Selection applied',
    //       value: 'col_name',
    //       class: 'filter_table',
    //     },
    //     {
    //       text: 'Parameter value',
    //       value: 'selected_value_min',
    //       class: 'filter_table',
    //     },
    //   ];
    //
    //   return {
    //     headers: headers,
    //     items: items,
    //   };
    // },
  },

  async mounted() {},
};
</script>

<style scoped></style>
